import React from 'react';

import './styles.css';

export default class About extends React.Component {
  render() {
    return (
      <div className="About Content" ref="dom">
        <h2 className="Title Title__center" id="fyrirtaekid">Fyrirtækið</h2>
        <p className="Paragraph Paragraph__center">
          SteinKompaníið er stofnað af þremur félögum sem hafa þekkst um árabil og hafa starfað í íslenskum steiniðnaði í áratugi, garðverktöku og steinsmíði jöfnum höndum.
        </p>
        <p className="Paragraph Paragraph__center">
          Saman reka þeir SteinKompaníið ehf. sem sinnir flestu því sem íslenskur steiniðnaður krefst, þó með megin áherslu á íslenskt hráefni og íslenskan veruleika.
        </p>
        <p className="Paragraph Paragraph__center">
          Samstarf við hönnuði og verkkaupa  er stór þáttur í starfsemi fyrirtækisins, auk sérsmíði hvers konar í stóru og smáu.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/about/index.js